import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, PLATFORM_ID, Inject, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';
import { TrustPilotComponent } from '../trust-pilot/trust-pilot.component';
import { ToHtmlPipe } from '../../utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-common-discover-why',
  templateUrl: './discover-why.component.html',
  styleUrls: ['./discover-why.component.scss'],
  imports: [CommonModule, UrlParamsPipe, TrustPilotComponent, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class CommonDiscoverWhyComponent implements OnInit, OnDestroy {
  @Input() discoverData: any;
  @Input() bgWhite: boolean = false;
  @Input() paddTop: boolean = true;
  @Input() hideTrustPilot: boolean = false;
  discoverPanelData: any;
  subscriptions: Subscription[];
  queryParams: any;
  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnInit(): void {
    if (this.discoverData != null && this.discoverData?.components) {
      this.discoverPanelData = this.discoverData;
      this.discoverPanelData.components[0].active = true;
    }
  }
  ngOnChanges(): void {
    if (this.discoverData != null && this.discoverData?.components) {
      this.discoverPanelData = this.discoverData;
      this.discoverPanelData.components[0].active = true;
    }
  }

  selectTab(event: any) {
    this.discoverPanelData.components.forEach((tab: any) => {
      tab.active = tab.fields.title === event.fields.title;
    });
  }
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }
}
